import { render } from "./BaseLink.vue?vue&type=template&id=07a6f030&scoped=true"
import script from "./BaseLink.vue?vue&type=script&lang=js"
export * from "./BaseLink.vue?vue&type=script&lang=js"

import "./BaseLink.vue?vue&type=style&index=0&id=07a6f030&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a6f030"]])

export default __exports__